import script from "./LegalFooterLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalFooterLinks.vue?vue&type=script&setup=true&lang=js"

import "./LegalFooterLinks.vue?vue&type=style&index=0&id=62446e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62446e4c"]])

export default __exports__